import api from "../../../api";

export const getFamilles = async () => {
  const res = await api.get("/familles");
  return res.data;
};

export const getConsolidation = async (id) => {
  const res = await api.get(`/familles/${id}/consolidation`);
  return res.data;
};

export const getFamilleById = async (id) => {
  const res = await api.get(`/familles/${id}`);
  return res.data;
};

export const updateFamille = async (id, data) => {
  const res = await api.put(`/familles/${id}`, data);
  return res.data;
};

export const createFamille = async (data) => {
  const res = await api.post("/familles", data);
  return res.data;
};

export const deleteFamille = async (id) => {
  const res = await api.delete(`/familles/${id}`);
  return res.data;
};

export const archiveFamille = async (id, data) => {
  const res = await api.post(`/familles/${id}/archive`, data);
  return res.data;
};

